// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-overlay{display:block;color:#fff;position:absolute;top:32px;left:32px;text-shadow:-1px 0 #000,0 1px #000,1px 0 #000,0 -1px #000;z-index:1000;pointer-events:none}.video-overlay .video-overlay-item{font-size:18px;margin-bottom:16px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
